import { productDescriptionStyles as styles } from "@insite/content-library/Components/ProductDescription";
import { css } from "styled-components";

styles.productDetailLink = {
    ...styles.productDetailLink,
    css: css`
        display: inline;
        width: auto !important;
        pointer-events: none;
        text-wrap: wrap;
    `,
    typographyProps: {
        css: css`
            ${styles.productDetailLink?.typographyProps?.css};
            width: auto !important;
            pointer-events: all;
        `,
    },
};
